module.exports = __webpack_public_path__ + "img/IMG_20200802_153612.16cd21f6.jpg";